import { render, staticRenderFns } from "./SoundSettings.vue?vue&type=template&id=6a7a71e6&scoped=true&lang=pug"
import script from "./SoundSettings.vue?vue&type=script&lang=js"
export * from "./SoundSettings.vue?vue&type=script&lang=js"
import style0 from "./SoundSettings.vue?vue&type=style&index=0&id=6a7a71e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a71e6",
  null
  
)

export default component.exports